import { Component } from '@angular/core';

@Component({
  selector: 'app-cells',
  imports: [],
  templateUrl: './cells.html',
  styleUrl: './cells.css'
})
export class Cells {

}
